/** Author: Codex CLI Agent // Generation: Custom Socket.IO path parsing // Version: v3.2.283 // Modified: 2026-04-02T19:48:00-07:00 */
export interface SocketTargetConfig {
  url: string;
  path?: string;
}

export function resolveSocketTarget(rawUrl: string): SocketTargetConfig {
  try {
    const parsed = new URL(rawUrl);
    const trimmedPath = parsed.pathname.replace(/\/+$/, '');
    return {
      url: `${parsed.protocol}//${parsed.host}`,
      path: trimmedPath && trimmedPath !== '/' ? trimmedPath : undefined
    };
  } catch {
    return { url: rawUrl };
  }
}
